import React, { useContext } from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
  IconButton,
} from "@mui/material";
import ListHeader from "./ListHeader";
import { DEFAULT_COUNTRY, MARKETPLACE, TAX_ID_LABELS } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { mongoTimeStampToString } from "../../utils/orders";
import { UserContext } from "../../contexts/userContext";
import { IListQuoteAudits } from "../../interfaces/order";
import ListPagination from "./ListPagination";

const ListQuoteAudits = ({
  audits,
  pagination,
  handlePageChange,
}: IListQuoteAudits) => {
  const {
    marketplaceIntegrations,
    currentUser: { entity, entityInfo },
  }: any = useContext(UserContext);
  const country = entityInfo?.country || DEFAULT_COUNTRY;
  const navigate = useNavigate();
  const COLUMNS = [
    { label: "Fecha de creación" },
    { label: "CP Origen" },
    { label: "CP Destino" },
    { label: "Fallo general" },
    { label: "Cantidad de Errores" },
    { label: "Acciones" },
  ];

  const showMerchantColumn = entity === MARKETPLACE && marketplaceIntegrations;
  if (showMerchantColumn) {
    COLUMNS.splice(1, 0, { label: "Merchant" });
    COLUMNS.splice(2, 0, { label: `Merchant ${TAX_ID_LABELS[country]}` });
  } else {
    COLUMNS.splice(1, 0, { label: "Marketplace" });
  }


  const getErrorQuantityFromResponses = (responses: any[]) =>
    responses.reduce((accum: number, audit) => {
      // Caso 1: errores explícitos
      if (Array.isArray(audit.errors) && audit.errors.length > 0) {
        return accum + audit.errors.length;
      }
      // Caso 2: caída de servicio o respuesta inválida
      const parsed =
        typeof audit.response === "string"
          ? JSON.parse(audit.response)
          : audit.response;
      if (!parsed || parsed.price === undefined) return accum + 1;

      return accum;
    }, 0);

  return (
    <TableContainer component={Paper} className="m-t-40 br-20 bg-light">
      <Table>
        <ListHeader columns={COLUMNS} />
        <TableBody>
          {audits.map((audit) => (
            <TableRow>
              <TableCell>{mongoTimeStampToString(audit.createdAt)}</TableCell>
              {showMerchantColumn && (
                <TableCell>
                  {audit.merchant.entity.name}
                </TableCell>
              )}
              {showMerchantColumn && (
                <TableCell>
                  {audit.merchant.entity.cuit}
                </TableCell>
              )}
              {!showMerchantColumn && (
                <TableCell>
                  {audit.client?.entity?.name}
                </TableCell>
              )}
              <TableCell>{audit.input?.originZipCode}</TableCell>
              <TableCell>{audit.input.destinationZipCode}</TableCell>
              <TableCell>
                <span
                  style={{
                    color: audit.allResponsesFailed ? "#d32f2f" : "#388e3c",
                    fontWeight: "bold",
                    padding: "4px 12px",
                    borderRadius: "8px",
                    background: audit.allResponsesFailed ? "#ffebee" : "#e8f5e9",
                    display: "inline-block",
                    minWidth: "40px",
                    textAlign: "center",
                  }}
                >
                  {audit.allResponsesFailed ? "Sí" : "No"}
                </span>
              </TableCell>
              <TableCell>
                {`${getErrorQuantityFromResponses(audit.responses)} errores`}
              </TableCell>
              <TableCell>
                <Tooltip title="Ver">
                  <IconButton
                    sx={{ padding: 0.5 }}
                    onClick={() => navigate(`cotizacion/${audit._id}`)}
                  >
                    <span className="material-symbols-rounded">visibility</span>
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <ListPagination
        total={pagination.count}
        page={pagination.page}
        onChangePage={handlePageChange}
      />
    </TableContainer>
  );
};

export default ListQuoteAudits;
